import { Reminder, TranslateFunction } from '@griply/types';

import { getReminderLabel } from './get-reminder-label';
import { sortReminders } from './reminder-list';

// Expects the task's effective reminders — a legacy `reminderTime` must be resolved before it gets here.
export const getRemindersSummaryLabel = (
  reminders: Reminder[] | null | undefined,
  t: TranslateFunction,
  formatOffset: (offset: number) => string | null,
): string | undefined => {
  // Sorted here rather than by the caller: insertion order differs per app for the
  // same picks, which would surface a different leading label on web than on mobile.
  const [first, ...others] = sortReminders(reminders ?? []);

  if (!first) {
    return undefined;
  }

  const label =
    getReminderLabel(first, t) ?? formatOffset(first.offset) ?? undefined;

  if (!label) {
    return undefined;
  }

  return others.length ? `${label} +${others.length}` : label;
};
